import { dauer as tonDauer } from '../lib/sprachaufnahme'
import { useTexte } from '../texte'

/**
 * Eine Sprachnachricht zum Anhören — **an einer Stelle**.
 *
 * **Ein eingebauter Player und kein eigener**: das Bedienelement des Geräts
 * kennt jeder, und ein nachgebauter kann weniger.
 *
 * Bis 1.35.0 stand er nur in der Sprechblase, und am Kartenpunkt gab es ihn
 * gar nicht — aus dem Betrieb gemeldet: „diese können zwar hinzugefügt werden
 * zu einem Punkt, werden aber im Punkt nicht angezeigt." Anhängen ging, die
 * Aufnahme zählte auf den Speicher, und zu hören war sie nirgends. Genau die
 * stille Absage, die `CLAUDE.md` verbietet.
 *
 * Deshalb hier und nicht zweimal: Chat und Punkt zeigen dasselbe Bauteil,
 * dieselbe Dauer, dieselbe Ersatzzeile.
 */
export function Tonspur({ url, dauerMs }: { url: string; dauerMs: number }) {
  const t = useTexte().chat
  return (
    <div className="tonblase">
      <audio controls preload="metadata" src={url} className="tonblase__player">
        {t.tonNichtAbspielbar}
      </audio>
      {dauerMs > 0 && <span className="tonblase__dauer">{tonDauer(dauerMs)}</span>}
    </div>
  )
}
